export default [
  'common',
  'names',
  'fruits',
  'animals',
  'common/adjectives',
  'common/adverbs',
  'common/bodyparts',
  'common/cities',
  'common/colours',
  'common/dndClass',
  'common/dndRace',
  'common/drinks',
  'common/location',
  'common/nouns',
  'common/places',
  'common/preposition',
  'common/rank',
  'common/timeofday',
  'common/timespan',
  'common/verbs'
]
